import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import Action from '../DebtPaymentComponents/action';
import Config from '../../../../Config';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';
import {report, getReportParams} from '../../../../middleware/report';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const NoAccountsErrorPrivate = (props) => {
  const [mount, setMount] = useState(false);

  let mainImg = require('../images/icons-error.svg');

  let title = 'שירות זה אינו זמין';
  let dial = require('../images/icons-call-phone.svg');
  let actionText = props.isMobile ? 'חיוג ' + numWithStarRTL(Config.businessCallNumber) + 'לאחראי שירות' : 'לפנייה לנציג שירות יש לחייג למספר ';

  //let bodyText = props.isMobile ? 'אנחנו לא יכולים להשלים כרגע את\n התהליך. כדאי לנסות שוב עוד כמה\n רגעים או להסדיר את התשלום דרך\n המוקד הפיננסי שלנו' :
  const actionOnClick = (e) => {
    gaEvent(
      gaParams.PRIVATEDEBT_SPECIALERROR_CALL_CLICK.category,
      gaParams.PRIVATEDEBT_SPECIALERROR_CALL_CLICK.eventType,
      `לא נמצאו חשבונות`,
    );
    window.open('tel:' + e);
  };

  useEffect(() => {
    if (props.currentStep === errorEnum.NOACCOUNTSPRIVATE) {
      setMount(true);
      gaEvent(gaParams.PRIVATEDEBT_SPECIALERROR_SHOW.category, gaParams.PRIVATEDEBT_SPECIALERROR_SHOW.eventType, `לא נמצאו חשבונות`);
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'Private Debt Payment';
      reportParams.channel = 'WebsitePrivate';
      reportParams.actionType = 'Debt List Page';
      reportParams.status = 'Completed';
      reportParams.messageText = 'No Account Exists';
      reportParams.subscriber = props.phoneNumber;
      report(reportParams);
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={20} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'לא ניתן לבצע את הפעולה'} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'מכיוון שלא נמצאו חשבונות'} />
          </Col>
        </Row>
        {props.isMobile ? (
          <Action text={'חיוג ' + numWithStarRTL(`${window.Config.technicalSupportPhone}`) + ' לנציג שירות'} img={dial} onclick={actionOnClick} fnParams={window.Config.technicalSupportPhone} bold />
        ) : (
          <Row className='justify-content-md-center'>
            <Col>
              <BasicText text={'חיוג ' + numWithStarRTL(`${window.Config.technicalSupportPhone}`) + ' לנציג שירות'} bold color='businessPurple' />
            </Col>
          </Row>
        )}
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default NoAccountsErrorPrivate;
